import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/panel`;

export const myCompanyUrls = {
  'app.myCompany': `${prefix}/my-company`,
  'app.myCompany.edit': `${prefix}/my-company/edit`,
}
